// extracted by mini-css-extract-plugin
export default {"ribbon":"b3_hS"};